import {
  CHANGE_LOADING,
  RESET_RECORD_INFO,
  SET_DIRECT_PARENT,
  SET_ELF,
  SET_ISIN,
  SET_MODIFICATIONS,
  SET_OVA,
  SET_RA,
  SET_RECORD,
  SET_RECORD_MODIFICATIONS,
  SET_RECORD_XML,
  SET_RR_XML,
  SET_REPEX_XML,
  SET_ULTIMATE_PARENT,
  SHOW_RECORD_EXCEPTION,
} from './mutations-types'
import { baseURL, exportSearchResultsUrl, } from '@/constants/api'
import {
  getEntityDispatches,
  getISINDispatches,
  getRelationshipsDispatches,
  getSubInfo,
  mutationsResolver,
} from './helpers/actions-helper'
import { needOtherELF, needOtherRA, parseModifications, } from '@/store/modules/record/helpers/parsing'

import { ADD_LEI_ISSUER, } from '@/store/modules/record/mutations-types'
import { getData, } from '../../helpers'
import showCodesPerPage from '@/utils/showCodesPerPage'

export default {
  getRecord ({ commit, state, dispatch, }, id) {
    return new Promise((resolve, reject) => {
      commit(RESET_RECORD_INFO)
      commit(CHANGE_LOADING, true)
      getData({ state, }, {
        endpoint: `lei-records/${id}`,
        cb: ({ meta, data, }) => {
          commit(SET_RECORD, {
            recordPublishDate: meta.goldenCopy.publishDate,
            record: data,
          })

          const getISINinfo = data.relationships.isins ? getISINDispatches(state, dispatch, id) : Promise.resolve()
          const entityDispatches = getEntityDispatches(id, state.record.entity, dispatch)
          const relationshipsDispatches =
            getRelationshipsDispatches(id, state.record.relationships, dispatch)
          const dispatchesSubInfo = getSubInfo(state, dispatch)

          Promise.all([
            // dispatch('getModifications', {id}), disable the call to the /modifications endpoint
            ...getISINinfo,
            ...entityDispatches,
            ...relationshipsDispatches,
            ...dispatchesSubInfo,
          ])
            .then(() => {
              commit(CHANGE_LOADING, false)
              resolve()
            })
        },
        cbCatch: () => {
          commit(SHOW_RECORD_EXCEPTION, true)
          console.error(`Record with ID ${id} is not found`)
          reject()
        },
      })
    })
  },
  getRecordXml ({ commit, state, }, { id, }) {
    commit(CHANGE_LOADING, true)
    return getData({ state, }, {
      endpoint: 'lei-records.xml',
      baseUrl: exportSearchResultsUrl,
      params: {
        filter: {
          lei: id,
        },
      },
      cb: (data) => {
        commit(SET_RECORD_XML, {
          id,
          data,
        })
        commit(CHANGE_LOADING, false)
      },
      cbCatch: () => {
        commit(CHANGE_LOADING, false)
      },
    })
  },
  getRelationshipOrRepexRecordXml ({ commit, state, }, { id, relationshipType, }) {
    commit(CHANGE_LOADING, true)
    const relationshipTypes = {
      directParent: 'direct-parent-relationship',
      ultimateParent: 'ultimate-parent-relationship',
      fundManager: 'fund-manager-relationship',
      umbrellaFund: 'umbrella-fund-relationship',
      masterFund: 'master-fund-relationship',
      headOffice: 'head-office-relationship',
      directParentException: 'direct-parent-reporting-exception',
      ultimateParentException: 'ultimate-parent-reporting-exception',
    }
    if (relationshipTypes.hasOwnProperty(relationshipType)) {
      const type = relationshipTypes[relationshipType]
      const isRepex = [ 'directParentException', 'ultimateParentException', ].includes(relationshipType)

      return getData({ state, }, {
        endpoint: `lei-records/${id}/${type}.xml`,
        baseUrl: exportSearchResultsUrl,
        cb: (data) => {
          isRepex ?
            commit(SET_REPEX_XML, {
              id,
              data,
              relationshipType,
            }) : commit(SET_RR_XML, {
              id,
              data,
              relationshipType,
            })
          commit(CHANGE_LOADING, false)
        },
        cbCatch: (e) => {
          commit(CHANGE_LOADING, false)
        },
      })
    }
  },
  getRecordModifications ({ commit, state, }, { id, page = 1, pageSize = 15, type, cb, }) {
    commit(CHANGE_LOADING, true)
    const filter = { recordType: type, }
    if (state.criteriaModifications.field) filter.field = state.criteriaModifications.field.xpath
    return getData({ state, }, {
      endpoint: `lei-records/${id}/field-modifications`,
      params: {
        filter,
        page: {
          size: pageSize,
          number: page,
        },
      },
      cb: (modifications) => {
        if (cb) {
          cb(modifications)
        } else {
          const { data, meta, } = modifications
          commit(SET_RECORD_MODIFICATIONS, {
            modificationsData: {
              data: parseModifications(data),
              type,
              pagination: meta.pagination,
            },
          })
        }
        commit(CHANGE_LOADING, false)
      },
      cbCatch: () => {
        commit(CHANGE_LOADING, false)
      },
    })
  },
  getISIN ({ commit, state, }, {
    id, params = {
      page: {
        number: 1,
        size: showCodesPerPage(window.innerWidth),
      },
    },
  }) {
    return getData({ state, }, {
      baseUrl: baseURL,
      endpoint: `lei-records/${id}/isins`,
      params,
      cb: (data) => {
        commit(SET_ISIN, data)
      },
      cbCatch: () => {
        console.error(`ISIN with ID ${id} is not found`)
      },
    })
  },
  getRelationships ({ commit, state, dispatch, }, { id, type, params = null, cb, }) {
    // TODO: rework for adding params
    const childLikeRelationships = [
      'ultimate-children',
      'direct-children',
      'branches',
      'managed-funds',
      'sub-funds',
      'feeder-funds',
    ]
    const defaultParams = childLikeRelationships.includes(type) ? {
      page: {
        size: state.childrenMaxCount,
        number: 1,
      },
    } : {}
    return getData({ state, }, {
      endpoint: `lei-records/${id}/${type}`,
      params: params || defaultParams,
      cb: (data) => {
        if (cb) {
          cb(data)
        } else {
          let mutation = mutationsResolver[type]
          commit(mutation, data)
          if (mutation === SET_DIRECT_PARENT || mutation === SET_ULTIMATE_PARENT) {
            // TODO podzigun.vitaliy 07.11.19: CHANGE_LOADING is not handled here
            dispatch('getEntitiesLeiIssuer', data.data)
          }
        }
      },
    })
  },
  getSubChildren ({ dispatch, commit, state, }, { id, page = 1, }) {
    return dispatch('getChildren', {
      id,
      page,
      cb: (data) => data,
    })
  },
  getSubRelationships ({ state, }, { id, page = 1, }) {
    return getData({ state, }, {
      endpoint: `lei-records/${id}/direct-child-relationships`,
      cb: (data) => data,
      params: {
        page: {
          size: 200,
          number: page,
        },
      },
    })
  },
  getChildren ({ commit, dispatch, state, }, { id, type = 'direct-children', page = 1, cb, }) {
    return dispatch('getRelationships', {
      id,
      type,
      params: {
        page: {
          size: state.childrenMaxCount,
          number: page,
        },
      },
      cb: cb ? (data) => cb(data) : null,
    })
  },
  getModifications ({ commit, state, }, { id, page = {}, }) {
    if (id) {
      return getData({ state, }, {
        params: { page, },
        endpoint: `lei-records/${id}/modifications`,
        cb: ({ data, meta, }) => {
          commit(SET_MODIFICATIONS, {
            data,
            meta,
          })
        },
      })
    }
  },
  getELF ({ commit, state, }, elf) {
    const needOther = needOtherELF(elf)
    if (!elf) {
      console.log('elf === null')
      return
    }
    if (needOther) {
      commit(SET_ELF, { needOther, })
    } else {
      return getData({ state, }, {
        endpoint: `entity-legal-forms/${elf}`,
        cb: ({ data, }) => {
          commit(SET_ELF, { data, })
        },
      })
    }
  },
  getRA ({ commit, state, }, ra) {
    const needOther = needOtherRA(ra)
    if (!ra) {
      return
    }
    if (needOther) {
      commit(SET_RA, { needOther, })
    } else {
      return getData({ state, }, {
        endpoint: `registration-authorities/${ra}`,
        cb: ({ data, }) => {
          commit(SET_RA, { data, })
        },
      })
    }
  },
  getOVA ({ commit, state, }, ra) {
    if (!ra.code) {
      return
    }

    const needOther = needOtherRA(ra.code)
    if (needOther) {
      commit(SET_OVA, {
        needOther,
        ra,
      })
    } else {
      return getData({ state, }, {
        endpoint: `registration-authorities/${ra.code}`,
        cb: ({ data, }) => {
          commit(SET_OVA, {
            data,
            ra,
          })
        },
      })
    }
  },
  getRelationshipRA ({ commit, state, }, { ra, rr, }) {
    const needOther = needOtherRA(ra)
    if (needOther) {
      commit(`SET_${rr}_RA`, { needOther, })
    } else {
      return getData({ state, }, {
        endpoint: `registration-authorities/${ra}`,
        cb: ({ data, }) => {
          commit(`SET_${rr}_RA`, { data, })
        },
      })
    }
  },

  getEntitiesLeiIssuer ({ commit, state, }, { id, registration = {}, }) {
    let leiIssuerId = registration.managingLou
    if (leiIssuerId && !state.leiIssuers[leiIssuerId]){
      return getData({ state, }, {
        endpoint: `lei-records/${id}/lei-issuer`,
        cb: ({ data, }) => {
          commit(ADD_LEI_ISSUER, { data, })
        },
      })
    }
  },
  getFullRelationships ({ commit, state, }, { id, queryType, }) {
    const typeResolver = queryType.toUpperCase().replaceAll('-', '_')
    let pageCounter = 1

    return getData({ state, }, {
      endpoint: `lei-records/${id}/${queryType}`,
      cb: ({ data, meta, }) => {
        commit(`SET_${typeResolver}_DATA`, { data, })
        if (meta.pagination){
          while (meta.pagination.lastPage !== pageCounter){
            pageCounter++
            getData({ state, }, {
              endpoint: `lei-records/${id}/${queryType}`,
              params: {
                page: {
                  size: 200,
                  number: pageCounter,
                },
              },
            }).then(({ data, }) => commit(`SET_${typeResolver}_DATA`, { data, }))
          }
        }
      },
      params: {
        page: {
          size: 200,
          number: pageCounter,
        },
      },
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/record/actions.js